import { render, staticRenderFns } from "./CompanyUsersForm.vue?vue&type=template&id=07d20880&scoped=true&"
import script from "./CompanyUsersForm.vue?vue&type=script&lang=js&"
export * from "./CompanyUsersForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyUsersForm.vue?vue&type=style&index=0&id=07d20880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d20880",
  null
  
)

export default component.exports